var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._t("default",[_c('p',[_vm._v("I'm the default header content")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }